import React, { PureComponent } from 'react';
import { Box, Flex } from 'rebass';
import styled from 'styled-components';
import { connect } from 'unistore/react';

import Actions from '~/state/Actions';
import { sizePerMemberSelector } from '~/state/Selectors';
import { nf, trackEvent } from '~/Utils';
import InfoIcon from '~/components/Header/Assets/info.svg';

import NumericInput from './NumericInput';

const ListItem = styled(Flex).attrs({
  justifyContent: 'space-between',
  py: 2,
})`
  border-top: ${(props) =>
    props.borderTop ? `1px solid ${props.theme.colors.lightblue}` : 'none'};
`;

const Label = styled.div`
  font-size: 14px;
  width: 60%;
`;

const InputWrapper = styled.div`
  width: 40%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
`;

const InfoIconStyled = styled(InfoIcon)`
  width: 15px;
  height: 15px;
  margin-left: 5px;
`;

const InfoBox = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 220px;
  pointer-events: none;
  user-select: none;
  font-size: 14px;
  background: rgba(255, 255, 255, 0.9);
  padding: 5px;
  border: 1px solid ${(p) => p.theme.colors.blue};
  z-index: 100;
`;

const IncomeDisplay = styled.div`
  text-align: center;
  width: 100%;
  font-weight: bold;
  max-width: 180px;
`;

class IncomeCalculator extends PureComponent {
  state = {
    showInfo: false,
    infoPosition: false,
  };

  infoButtonRef = React.createRef();

  containerRef = React.createRef();

  handleInfoIcon() {
    const infoBtnPosition = this.infoButtonRef.current.getBoundingClientRect();
    const containerPosition = this.containerRef.current.getBoundingClientRect();

    const infoPosition = {
      top: infoBtnPosition.top - containerPosition.top + 20,
      left: Math.max(infoBtnPosition.left - containerPosition.left - 100, 0),
    };

    this.setState({
      showInfo: true,
      infoPosition,
    });
  }

  handleInfoIconOut() {
    this.setState({ showInfo: false });
  }

  render() {
    const { householdSize, householdMembers } = this.props;

    const { infoPosition, showInfo } = this.state;

    const sizePerMember = householdSize / householdMembers;

    const infoStyle = infoPosition
      ? {
          top: infoPosition.top,
          left: infoPosition.left,
        }
      : {};

    const onSizeChange = (size) => {
      this.props.setHouseholdSize(size);
    };

    const setHouseholdMembers = (members) => {
      this.props.setHouseholdMembers(members);
    };

    const parser = (value) => {
      const result = +value.replace('.', '');
      if (isNaN(result)) {
        return 0;
      }
      return Math.max(0, Math.min(result, 1000));
    };

    return (
      <Box style={{ position: 'relative' }} my={3} ref={this.containerRef}>
        {showInfo && (
          <InfoBox style={infoStyle}>
            Einkommen umfassen alle Einnahmen der Haushaltsmitglieder, zum Beispiel Löhne, Zinsen,
            Mieteinnahmen, Unterhaltszahlungen, Renten (nach Abzug von Steuern und inklusive
            Transfers wie Kindergeld). Im Fall einer selbst bewohnten Immobilie werden auch die
            gesparten Mietausgaben addiert (abzüglich der Kosten für Hypotheken und Instandhaltung).
          </InfoBox>
        )}
        <ListItem>
          <Label>Wie groß ist Ihre Wohnung?</Label>
          <InputWrapper>
            <NumericInput
              // formatter={nf}
              // parser={parser}
              min={0}
              // step={1}
              max={1000}
              onChange={onSizeChange}
              value={householdSize}
            />
          </InputWrapper>
        </ListItem>
        <ListItem>
          <Label>Wie viele Personen leben in ihrem Haushalt?</Label>
          <InputWrapper>
            <NumericInput
              min={1}
              max={10}
              onChange={setHouseholdMembers}
              value={householdMembers}
            />
          </InputWrapper>
        </ListItem>
        <ListItem borderTop>
          <Label>Jedes Haushaltsmitglied bewohnt diese Fläche in Quadratmetern: </Label>
          <InputWrapper>
            <IncomeDisplay>{nf(sizePerMember)}</IncomeDisplay>
          </InputWrapper>
        </ListItem>
      </Box>
    );
  }
}

export default connect(
  (state) => ({
    sizePerMember: sizePerMemberSelector(state),
    householdSize: state.householdSize,
    householdMembers: state.householdMembers,
  }),
  Actions
)(IncomeCalculator);
